import { useParams } from "@tanstack/react-router";
import { buildOrgPath } from "@/common/utils/orgRouteUtils";

export function useOrgPath() {
  const params = useParams({ strict: false }) as {
    organizationBusinessUnitId?: string;
    orgId?: string;
  };
  const organizationBusinessUnitId = params.organizationBusinessUnitId;

  return (subPath: string): string => {
    if (!organizationBusinessUnitId) {
      return `/org${subPath}`;
    }
    return buildOrgPath(organizationBusinessUnitId, subPath);
  };
}
